import type {ReactElement} from 'react';
import React from 'react';
import {setSelectedCamera} from '@Panels/record-image-and-video-panel/record-image-and-video-panel-reducer';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import styles from '@Panels/record-image-and-video-panel/components/stop-video-recording-button/stop-video-recording-button.module.scss';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import {ImageAndVideoRecorderStatus} from '@Panels/record-image-and-video-panel/record-image-and-video.types';
import {useAppDispatch, useAppSelector} from '@/hooks';

interface CameraDeviceToggleProps {
  videoInputDevices: Array<string>;
  getCamera(cameraId?: string): Promise<void>;
}

export function CameraDeviceToggle({...props}: CameraDeviceToggleProps): ReactElement | null {
  const dispatch = useAppDispatch();

  const selectedCamera = useAppSelector((state) => {
    return state.recordImageAndVideoPanel.selectedCamera;
  });

  const recorderStatus = useAppSelector((state) => {
    return state.recordImageAndVideoPanel.imageAndVideoRecorderStatus;
  });

  const handleToggleCamera = async (): Promise<void> => {
    let currentCameraIndex = 0;

    if (selectedCamera) {
      currentCameraIndex = props.videoInputDevices.indexOf(selectedCamera);
    }

    dispatch(setSelectedCamera({selectedCamera: props.videoInputDevices[(currentCameraIndex + 1) % props.videoInputDevices.length]}));
  };

  return (
    <div className="flex-h-row flex-items-center">
      <ClickableDiv
        onClick={() => {
          void handleToggleCamera();
        }}
        className={`${styles.button} hover-transition-all flex-center`}
      >
        <Icon
          className={!props.videoInputDevices || props.videoInputDevices.length < 2 || recorderStatus === ImageAndVideoRecorderStatus.RECORDING ? '_invisible' : ''}
          icon="icon-refresh"
          size={IconSize.SIZE_ICON_20}
          shape={IconShape.CIRCLE}
          type={IconType.SECONDARY}
        />
      </ClickableDiv>
    </div>
  );
}
